var _templateObject = _taggedTemplateLiteral(['\n  ', '\n\n  animation: ', ';\n  animation-fill-mode: backwards;\n'], ['\n  ', '\n\n  animation: ', ';\n  animation-fill-mode: backwards;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  ', '\n'], ['\n  ', '\n']);

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var __rest = this && this.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};
import * as React from 'react';
import ProgressBar from 'react-toolbox/lib/progress_bar/ProgressBar';
import compose from 'recompose/compose';
import lifecycle from 'recompose/lifecycle';
import withState from 'recompose/withState';
import styled from 'styled-components';
import { fadeIn } from 'styled-material';
import { normalizeColor } from 'styled-material';
var SpinnerContainer = styled.div(_templateObject, function (_ref) {
    var center = _ref.center;
    return center && '\n    position: absolute;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n  ';
}, fadeIn);
var StyledProgressBar = styled(ProgressBar)(_templateObject2, function (_ref2) {
    var size = _ref2.size,
        type = _ref2.type;
    return type === 'circular' && '\n    width: ' + size + 'px !important;\n    height: ' + size + 'px !important;\n  ';
});
export var enhance = compose(withState('visible', 'setVisible', false), lifecycle({
    componentDidMount: function componentDidMount() {
        var _this = this;

        var timeout = this.props.timeout;

        if (timeout !== false) {
            this.timeout = setTimeout(function () {
                _this.props.setVisible(true);
            }, timeout === undefined ? 300 : timeout);
        }
    },
    componentWillUnmount: function componentWillUnmount() {
        if (this.timeout) {
            clearTimeout(this.timeout);
        }
    }
}));
export var StatelessSpinner = function StatelessSpinner(_a) {
    var _a$size = _a.size,
        size = _a$size === undefined ? 28 : _a$size,
        _a$background = _a.background,
        background = _a$background === undefined ? false : _a$background,
        center = _a.center,
        timeout = _a.timeout,
        visible = _a.visible,
        props = __rest(_a, ["size", "background", "center", "timeout", "visible"]);

    return React.createElement(SpinnerContainer, { center: center, style: background && {
            backgroundColor: background === true ? 'white' : normalizeColor(background)
        } || {} }, (timeout === false || visible) && React.createElement(StyledProgressBar, Object.assign({}, props, { size: size })));
};
export var Spinner = enhance(StatelessSpinner);
//# sourceMappingURL=spinner.js.map
